// extracted by mini-css-extract-plugin
export default {"errorNotification":"ErrorCard_errorNotification__Kkas6","infoIcon":"ErrorCard_infoIcon__kLf4q"};